import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { DISCONNECT_PLUGIN } from 'constants/plugins';

import { MESSENGER } from 'constants/chats';

import { ReactComponent as SllrLogo } from 'assets/icons/SllrLogo.svg';
import { ReactComponent as DisconnectIcon } from 'assets/bosta-icons/disconnect-icon.svg';

import './DisconnectModal.less';

const DisconnectModal = ({ currentPlatform }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="br-disconnect-plugin__body-container">
      <div
        className={classnames('br-disconnect-plugin__icons-section', {
          'br-disconnect-plugin__icons-section__messenger':
            currentPlatform.key === MESSENGER
        })}
      >
        <SllrLogo />
        <DisconnectIcon className="br-disconnect-plugin__icons-section__disconnect-icon" />
        {currentPlatform.icon}
      </div>
      <div className="br-disconnect-plugin__description body-medium">
        <span>
          {formatMessage({
            id: `chats_plugins.install_plugins.discount_lose_the_following`
          })}
        </span>
      </div>
      <div className="br-disconnect-plugin__steps">
        <div className="br-disconnect-plugin__connection-steps">
          {DISCONNECT_PLUGIN.map(({ id, title }) => (
            <div
              key={id}
              className="br-disconnect-plugin__connection-steps--content"
            >
              <span
                className={classnames(
                  'br-disconnect-plugin__connection-steps--id text-gray'
                )}
              >
                {id}.
              </span>
              <span className="br-disconnect-plugin__connection-steps--title">
                {title}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DisconnectModal;
